// extracted by mini-css-extract-plugin
module.exports = {"infoSection":"Info_infoSection__lMTkD","Infocard":"Info_Infocard__fdwO-","info_svg":"Info_info_svg__3Z7ag","card_subheading":"Info_card_subheading__2ranh"};